import React, { useState, useEffect } from 'react';
// Custom SVG Icon Components - Guaranteed Outline Style
const StarIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
  </svg>
);

const CalendarIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const HandshakeIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="m11 17 2 2a1 1 0 1 0 3-3" />
    <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
    <path d="m21 3 1 11h-2" />
    <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
    <path d="M3 4h8" />
  </svg>
);

const GiftIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20,12 20,22 4,22 4,12" />
    <rect x="2" y="7" width="20" height="5" />
    <line x1="12" y1="22" x2="12" y2="7" />
    <path d="m12 7-3-3a3 3 0 0 0-3 3 3 3 0 0 0 3 3z" />
    <path d="m12 7 3-3a3 3 0 0 1 3 3 3 3 0 0 1-3 3z" />
  </svg>
);

const SportingExperiencesIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M8 12h8" />
    <path d="M12 8v8" />
    <path d="M16.24 7.76l-8.48 8.48" />
    <path d="M7.76 7.76l8.48 8.48" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const ArrowRightIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12,5 19,12 12,19" />
  </svg>
);

const ImageIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21,15 16,10 5,21" />
  </svg>
);
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Gallery } from './Gallery';
import { SportsModal } from './SportsModal';
import { CelebrityModal } from './CelebrityModal';
import { EventModal } from './EventModal';
import { SponsorshipModal } from './SponsorshipModal';
import { MerchandisingModal } from './MerchandisingModal';

export const Services = () => {
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [sportsModalOpen, setSportsModalOpen] = useState(false);
  const [celebrityModalOpen, setCelebrityModalOpen] = useState(false);
  const [eventModalOpen, setEventModalOpen] = useState(false);
  const [sponsorshipModalOpen, setSponsorshipModalOpen] = useState(false);
  const [merchandisingModalOpen, setMerchandisingModalOpen] = useState(false);

  // Return fallback/default images for a service synchronously
  const getDefaultServiceImages = (service) => {
    // Return just the URL strings that Gallery expects
    const images = [];

    // Add main service image first
    images.push(service.image);

    if (service.id === 'celebrity') {
      // Add celebrity gallery images - celebrity4.jpg moved to end
      const celebrityImages = [
        '/images/celebrity/celebrity_new_3.jpg',
        '/images/celebrity/Sharman%20GLS.jpeg',
        '/images/celebrity/Sharman%20GLS-2.jpeg',
        '/images/celebrity/Sharman%20GLS-3.jpeg',
        '/images/celebrity/celebrity8.png',
        '/images/celebrity/celebrity9.png',
        '/images/celebrity/celebrity_new_1.jpg',
        '/images/celebrity/celebrity_new_2.jpg',
        '/images/celebrity/celebrity6.png',
        '/images/celebrity/celebrity7.png',
        '/images/celebrity/celebrity4.jpg'
      ];
      images.push(...celebrityImages);
    }

    if (service.id === 'events') {
      // Add event gallery images - rearranged per user request
      images.push(
        '/images/events/event_mi_meet_greet.jpg',                    // 1st (unchanged)
        '/images/events/WhatsApp Image 2025-08-20 at 11.36.45_e02f43ed_1756930852815.jpg',  // 2nd (moved from 5th)
        '/images/events/event_hardik_mandira.jpg',                   // 3rd (unchanged)
        '/images/events/BNP Merch (2)_1758151853433.png',          // 4th (unchanged)
        '/images/events/WhatsApp Image 2025-09-03 at 12.17.47_898c7848_1757073296179.jpg',  // 5th (moved from 6th)
        '/images/events/WhatsApp Image 2025-09-03 at 12.29.01_69f7cb7d_1757073129682.jpg',  // 6th (moved from 7th)
        '/images/events/WhatsApp Image 2025-09-03 at 12.31.34_0a405365_1756931201118.jpg',  // 7th (moved from 8th)
        '/images/events/WhatsApp Image 2025-09-03 at 12.31.34_d115d7bb_1756931210168.jpg',  // 8th (moved from 9th)
        '/images/events/Axis Bhajji Harsha_1756933332556.png',      // 9th (moved from 10th)
        '/images/events/Untitled design_1758151853433.jpg',         // 10th (moved from 11th)
        '/images/events/event_gallery_1.jpg'                        // 11th (moved from 2nd - now at end)
      );
    }

    if (service.id === 'sponsorship') {
      // Add sponsorship gallery images - rearranged per user request
      images.push(
        '/images/sponsorship/ajivasan_event_2.jpg',          // 1st (unchanged)
        '/images/sponsorship/ajivasan_collage.png',          // 2nd (unchanged)
        '/images/sponsorship/ajivasan_lineup.png',           // 3rd (unchanged)
        '/images/sponsorship/image_1757073043223.png',       // 4th (unchanged)
        '/images/sponsorship/image7.jpg',                    // 5th (restored)
        '/images/sponsorship/image8.jpg',                    // 6th (restored)
        '/images/sponsorship/image3.png',                    // 7th (moved from 5th)
        '/images/sponsorship/image4.png',                    // 8th (moved from 6th)
        '/images/sponsorship/image5.png',                    // 9th (moved from 7th)
        '/images/sponsorship/image_1756386859876.png',       // 10th (moved from 8th)
        '/images/sponsorship/Ebix MI.jpg',                   // 11th (moved from 9th)
        '/images/sponsorship/image9.png',                    // 12th (moved from 10th)
        '/images/sponsorship/image10.png',                   // 13th (moved from 11th)
        '/images/sponsorship/image_1756504964665.png',       // 14th (moved from 12th)
        '/images/sponsorship/image_1756386274483.png'        // 15th (moved from 13th)
      );
    }

    if (service.id === 'merchandising') {
      // Add merchandising gallery images
      images.push(
        '/images/merchandising/merchandising_gallery_3.jpg',
        '/images/merchandising/merchandising_gallery_4.jpg',
        '/images/merchandising/merchandising_gallery_5.png',
        '/images/merchandising/merchandising_gallery_8.png',
        '/images/merchandising/merchandising_gallery_9.png',
        '/images/merchandising/merchandising_gallery_10.png',
        '/images/merchandising/merchandising_gallery_11.png',
        '/images/merchandising/merchandising_gallery_12.png',
        '/images/merchandising/merchandising_gallery_14.png',
        '/images/merchandising/merchandising_gallery_15.png',
        '/images/merchandising/merchandising_gallery_16.png'
      );
    }

    if (service.id === 'sports') {
      // Add sports gallery images
      images.push(
        '/images/sports/sports_stadium_experience_2.jpg',
        '/images/sports/WhatsApp Image 2025-08-20 at 13.25.38_c75b630f_1756414062844.jpg'
      );
    }

    return images;
  };

  // Dynamic gallery images state (populated from manifest.json in public/images/*)
  const [galleryImages, setGalleryImages] = useState([]);

  // Load images when gallery is opened for a service
  useEffect(() => {
    let cancelled = false;
    const loadImagesForService = async (service) => {
      if (!service) return;

      // derive folder name from service id
      const folder = service.id;
      try {
        const res = await fetch(`/images/${folder}/manifest.json`);
        if (!res.ok) throw new Error('manifest fetch failed');
        const filenames = await res.json();
        if (Array.isArray(filenames) && filenames.length > 0) {
          const urls = filenames.map(f => `/images/${folder}/${encodeURI(f)}`);
          if (!cancelled) setGalleryImages(urls);
          return;
        }
      } catch (e) {
        // fall through to defaults
      }

      // fallback: use the default list compiled from code
      const defaults = getDefaultServiceImages(service);
      if (!cancelled) setGalleryImages(defaults);
    };

    if (galleryOpen && selectedService) {
      loadImagesForService(selectedService);
    } else if (!galleryOpen) {
      setGalleryImages([]);
    }

    return () => { cancelled = true; };
  }, [galleryOpen, selectedService]);

  const openGallery = (service) => {
    setSelectedService(service);
    setGalleryOpen(true);
  };

  const closeGallery = () => {
    setGalleryOpen(false);
    setSelectedService(null);
  };

  const services = [
    {
      id: 'celebrity',
      icon: StarIcon,
      title: 'Celebrity Management',
      subtitle: 'Strategic Star Power',
      description: 'We know which celebrities genuinely connect with your audience and create authentic partnerships. Our relationships run deep in Bollywood, sports, and digital - we get you the right star who actually resonates with your brand story.',
      features: [
        'Direct access to top-tier talent',
        'End-to-end campaign execution',
        'Media production coordination',
        'Performance tracking & ROI'
      ],
      gradient: 'from-blue-600 to-purple-600',
      bgGradient: 'from-blue-50 to-purple-50',
      iconColor: 'text-purple-600',
      arrowColor: '#3b82f6',
      image: '/images/celebrity/celebrity_cover_new.jpg?v=' + Date.now()
    },
    {
      id: 'events',
      icon: CalendarIcon,
      title: 'Event Management',
      subtitle: 'Unforgettable Experiences',
      description: "From intimate team-building offsites to massive product launches, we handle the chaos so you can enjoy the applause. Think of us as your backstage crew - invisible to guests, indispensable to you.",
      features: [
        'Complete event production',
        'Celebrity talent booking',
        'Strategic budget optimization',
        'Seamless execution delivery'
      ],
      gradient: 'from-amber-600 to-yellow-600',
      bgGradient: 'from-amber-50 to-yellow-50',
      iconColor: 'text-amber-600',
      arrowColor: '#d97706',
      image: 'https://customer-assets.emergentagent.com/job_text-revamp-site/artifacts/yzxbbm8q_IMG-20250820-WA0010.jpg'
    },
    {
      id: 'sponsorship',
      icon: HandshakeIcon,
      title: 'Sponsorship Management',
      subtitle: 'Strategic Partnerships',
      description: 'Sponsorship deals can make or break budgets. We hunt down opportunities that fit your brand DNA and negotiate terms that make your CFO smile. No fluffy metrics - just partnerships that move the needle.',
      features: [
        'Strategic opportunity mapping',
        'Performance measurement',
        'Deal negotiation & closure',
        'Long-term partnership building'
      ],
      gradient: 'from-purple-600 to-pink-600',
      bgGradient: 'from-purple-50 to-pink-50',
      iconColor: 'text-pink-600',
      arrowColor: '#ec4899',
      image: '/images/sponsorship/ajivasan_event_1.jpg'
    },
    {
      id: 'merchandising',
      icon: GiftIcon,
      title: 'Merchandising & Corporate Gifting',
      subtitle: 'Brand Enhancement',
      description: 'Merchandise that recipients actually keep and use. We develop products that speak your brand story and find a place in the hearts of your audience, not generic promotional items that end up forgotten.',
      features: [
        'Premium product sourcing',
        'Custom design development',
        'Quality control & logistics',
        'Brand impact measurement'
      ],
      gradient: 'from-amber-700 to-orange-600',
      bgGradient: 'from-amber-50 to-orange-50',
      iconColor: 'text-orange-600',
      arrowColor: '#ea580c',
      image: 'https://customer-assets.emergentagent.com/job_text-revamp-site/artifacts/0udluumv_WhatsApp%20Image%202025-08-20%20at%2013.24.58_b1af1461.jpg'
    },
    {
      id: 'sports',
      icon: SportingExperiencesIcon,
      title: 'Sporting Experiences',
      subtitle: 'World-Class Access',
      description: "Stadium access most people dream about. Player meet-and-greets, luxury boxes, post-match celebrations - we get you inside the ropes at the biggest sporting moments across the globe.",
      features: [
        'Premium event access worldwide',
        'Complete travel & hospitality',
        'Behind-the-scenes experiences',
        'Corporate hospitality packages'
      ],
      gradient: 'from-indigo-600 to-blue-600',
      bgGradient: 'from-indigo-50 to-blue-50',
      iconColor: 'text-blue-600',
      arrowColor: '#2563eb',
      image: 'https://customer-assets.emergentagent.com/job_text-revamp-site/artifacts/i8nsxsqj_WhatsApp%20Image%202025-08-20%20at%2013.24.58_04efbe61.jpg'
    }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="py-16 bg-white relative">
      {/* Simplified Background Pattern - Non-blocking */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-gray-100"></div>
        </div>
      </div>

      {/* Removed the duplicate H2 tag */}

      {services.map((service, index) => (
        <section
          key={service.id}
          id={service.id}
          className={`py-16 relative ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
        >
          {/* Simplified Section Background - Non-blocking */}
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute inset-0 opacity-10">
              <img
                src={service.image}
                alt={`${service.title} Background`}
                className="w-full h-full object-cover"
              />
            </div>
            <div className={`absolute inset-0 ${index % 2 === 0 ? 'bg-white/98' : 'bg-gray-50/98'}`}></div>
          </div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''
              }`}>

              {/* Content Side */}
              <div className={`space-y-6 sm:space-y-8 ${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                <div className="space-y-3 sm:space-y-4">
                  <div className="flex items-center gap-3 sm:gap-4">
                    <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center flex-shrink-0">
                      <service.icon className={`w-8 h-8 sm:w-12 sm:h-12 stroke-1 ${service.iconColor}`} />
                    </div>
                    <div className="min-w-0">
                      <p className="text-xs sm:text-sm font-medium text-gray-600 uppercase tracking-wide">
                        {service.subtitle}
                      </p>
                      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 font-heading leading-tight">
                        {service.title}
                      </h2>
                    </div>
                  </div>

                  <p className="text-base sm:text-lg lg:text-xl text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>

                {/* Features List */}
                <div className="space-y-3 sm:space-y-4">
                  <ul className="space-y-2 sm:space-y-3">
                    {service.features.map((feature, featureIndex) => (
                      <li key={`${service.id}-feature-${featureIndex}`} className="flex items-start gap-2 sm:gap-3 text-gray-700 group/bullet cursor-pointer">
                        <svg className={`w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 mt-0.5 transform transition-transform duration-300 group-hover/bullet:scale-125 ${service.id === 'celebrity' ? 'text-blue-600' :
                          service.id === 'events' ? 'text-amber-600' :
                            service.id === 'sponsorship' ? 'text-pink-600' :
                              service.id === 'merchandising' ? 'text-orange-600' :
                                service.id === 'sports' ? 'text-blue-600' : 'text-gray-400'
                          }`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <line x1="5" y1="12" x2="19" y2="12" />
                          <polyline points="12,5 19,12 12,19" />
                        </svg>
                        <span className="text-sm sm:text-base transition-all duration-300 group-hover/bullet:text-gray-900 group-hover/bullet:scale-105 leading-relaxed">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <Button
                  onClick={() => {
                    switch (service.id) {
                      case 'celebrity':
                        setCelebrityModalOpen(true);
                        break;
                      case 'events':
                        setEventModalOpen(true);
                        break;
                      case 'sponsorship':
                        setSponsorshipModalOpen(true);
                        break;
                      case 'merchandising':
                        setMerchandisingModalOpen(true);
                        break;
                      case 'sports':
                        setSportsModalOpen(true);
                        break;
                      default:
                        scrollToSection('contact');
                    }
                  }}
                  className={`bg-gradient-to-r ${service.gradient} text-white hover:opacity-90 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl px-6 sm:px-8 py-2.5 sm:py-3 text-base sm:text-lg group w-full sm:w-auto`}
                >
                  Learn More
                  <ArrowRightIcon />
                </Button>
              </div>

              {/* Visual Side */}
              <div className={`${index % 2 === 1 ? 'lg:col-start-1' : ''} mt-6 lg:mt-0`}>
                <div
                  className="relative group cursor-pointer transform transition-all duration-500 hover:scale-105"
                  onClick={() => openGallery(service)}
                >
                  {/* Main Service Image */}
                  <div className="relative overflow-hidden rounded-xl sm:rounded-2xl aspect-[4/3] bg-gradient-to-br from-gray-100 to-gray-200">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      onError={(e) => {
                        console.error(`Failed to load image: ${service.image}`);
                        e.target.src = 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&h=600&fit=crop&q=80';
                      }}
                    />

                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                    {/* Click to view gallery overlay */}
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="bg-black/70 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold backdrop-blur-sm">
                        Click to view gallery
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* Gallery Modal */}
      <Gallery
        isOpen={galleryOpen}
        onClose={closeGallery}
        service={selectedService}
        images={galleryImages}
      />

      {/* All Service Modals */}
      <SportsModal
        isOpen={sportsModalOpen}
        onClose={() => setSportsModalOpen(false)}
      />

      <CelebrityModal
        isOpen={celebrityModalOpen}
        onClose={() => setCelebrityModalOpen(false)}
      />

      <EventModal
        isOpen={eventModalOpen}
        onClose={() => setEventModalOpen(false)}
      />

      <SponsorshipModal
        isOpen={sponsorshipModalOpen}
        onClose={() => setSponsorshipModalOpen(false)}
      />

      <MerchandisingModal
        isOpen={merchandisingModalOpen}
        onClose={() => setMerchandisingModalOpen(false)}
      />
    </div>
  );
};